<template>
  <div>
    <label for="docs-from">
      {{currentPartner.franchiseRelation.legalSlave.legal_person_name}}
    </label>
    <form id="docs-from" class="needs-validation" @submit.prevent="submitEditPayer">
      <div class="form-group">
        <label for="partnerData_contractDate">Дата документов (для генерации)</label>
        <input
            id="partnerData_contractDate"
            v-model="docDate"
            type="date"
            class="form-control form-control-sm"
        />
      </div>


      <div class="form-group">
        <div v-for="(item, code) in docs" :key="code">
          <div class="row">
            <div v-if="item.exist"
                 class="col-6 btn btn-sm btn-secondary"
                 @click="downloadPrimaryDocument(currentPartner, item)"
            >
              <i class="fas"></i> Скачать {{item.typeName}} ({{item.updatedAt}})
            </div>
            <div v-else
                 class="col-6 btn btn-sm btn-outline-success"
                 @click="downloadPrimaryDocument(currentPartner, item)"
            >
              <i class="fas"></i> Сформировать и скачать {{item.typeName}}
            </div>
            <div v-if="item.exist" class="col-5 offset-1">
              <div class="btn btn-sm btn-outline-success align-self-center"
                   @click="rebuildPrimaryDocsData(currentPartner, item)"
              >
                <i class="fas"></i> Переформировать
              </div>
            </div>
          </div>
          <div class="row"><br></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PartnerPrimaryDocsList",
  created() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    // Записываем результат в переменную, v-model автоматически обновит инпут
    this.docDate = `${year}-${month}-${day}`;
  },
  data() {
    // let docs = this.generateFormData();
    return {
      docDate: new Date(),
      currentPartner: {
        franchiseRelation: {
          legalSlave: {
            legal_person_name: null
          }
        }
      },
      docs: {
        unit_setup_contract: {
          templateCode: 'unit_setup_contract',
          typeName: 'Договор размещения оборудования',
          docId: null,
          partnerId: null,
          exist: false,
          buttonName: 'Сформировать и скачать ',
          createdAt: '',
          updatedAt: '',
        },
        attachment_001_specification_for_units: {
          templateCode: 'attachment_001_specification_for_units',
          typeName: 'Приложение №1. СПЕЦИФИКАЦИЯ на оборудование (имущество)',
          docId: null,
          partnerId: null,
          exist: false,
          buttonName: 'Сформировать и скачать ',
          createdAt: '',
          updatedAt: '',
        },
      },
      // docs: this.generateFormData(),
      submitted: false,
    }
  },
  methods: {
    setNullFormData() {
      this.initFormData();
      // this.docs =[];
    },
    generateFormData () {
      return  {
        unit_setup_contract: {
          templateCode: 'unit_setup_contract',
          typeName: 'Договор размещения оборудования',
          docId: null,
          partnerId: null,
          exist: false,
          buttonName: 'Сформировать и скачать ',
          createdAt: '',
          updatedAt: '',
        },
        attachment_001_specification_for_units: {
          templateCode: 'attachment_001_specification_for_units',
          typeName: 'Приложение №1. СПЕЦИФИКАЦИЯ на оборудование (имущество)',
          docId: null,
          partnerId: null,
          exist: false,
          buttonName: 'Сформировать и скачать ',
          createdAt: '',
          updatedAt: '',
        },
      };
    },
    initFormData() {
      this.docs = this.generateFormData();
    },
    setFormData(data) {
      for (let currentDocCode in this.docs) {
        if (data[currentDocCode] !== undefined) {
          this.docs[currentDocCode] = {
            templateCode: this.docs[currentDocCode].templateCode, // сохраняем текущий
            typeName: this.docs[currentDocCode].typeName, // сохраняем текущий
            docId: data[currentDocCode].id,
            partnerId: data[currentDocCode].partner_id,
            exist: true,
            buttonName: 'Скачать ',
            updatedAt: 'Сформировано '
                + new Date(data[currentDocCode].updated_at * 1000).toLocaleString('ru-RU'),
          };
        } else {
          this.docs[currentDocCode] = {
            templateCode: this.docs[currentDocCode].templateCode, // сохраняем текущий
            typeName: this.docs[currentDocCode].typeName, // сохраняем текущий
            docId: null,
            partnerId: null,
            exist: false,
            buttonName: 'Сформировать и скачать ',
            createdAt: '',
            updatedAt: '',
            };
        }
      }
    },
    rebuildPrimaryDocsData(partner, item) {
      let formData = new FormData();
      formData.append('id', partner.id);
      formData.append('template_code', item.templateCode);
      formData.append('doc_date', this.docDate);

      axios
          .post(`/v1/partners/rebuild-primary-document`, formData)
          .then(resp => {
            this.getPrimaryDocsData(this.currentPartner);
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },
    getPrimaryDocsData(partner) {
      this.currentPartner = partner;

      axios
          .get(`/v1/partners/get-primary-documents?id=` + partner.id)
          .then(resp => {
            this.initFormData();
            this.setFormData(resp.data);
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },
    async downloadPrimaryDocument(partner, item){

      let formData = new FormData();
      formData.append('id', partner.id);
      formData.append('template_code', item.templateCode);
      formData.append('doc_date', this.docDate);

      const resp = await axios
          .post(`/v1/partners/download-primary-document`, formData, {responseType: 'blob'})
          .then(resp => {
            const fileExtension = resp.headers['stored-file-extension'];
            const filename = item.typeName + '(' + partner.franchiseRelation.legalSlave.legal_person_name + ')' + fileExtension;
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');

            this.getPrimaryDocsData(partner);

            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },
  },
}
</script>

<style scoped lang="scss">

</style>